









import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
@Component
export default class VerifyCode extends Vue {
	@Prop() private phone!: string
	@Prop() private beforeClick!: any
	@Prop ({
		type: Number,
		required: true,
		default: ''
	}) private type!: number
	@Prop() private verifyImgCode!: string
	@Prop() private uuid!: string
	private verifyCodeTime: number = 0
	private verifyCodeInterval: any = null
	private destoryed = () => {
		if (this.verifyCodeInterval) {
			clearInterval(this.verifyCodeInterval)
		}
	}
	private getVerifyCode () {
		if (this.verifyCodeTime > 0) {
			return false
		}
		if (this.beforeClick) {
			this.beforeClick().then(() => {
				this.getVerifyCodeHandler()
			})
		} else {
			this.getVerifyCodeHandler()
		}
	}
	private getVerifyCodeHandler (): void {
		const params = {
			type: this.type,
			data: this.phone,
			uuid: this.uuid,
			verifyCode: this.verifyImgCode
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/vCode/get',
			data: params,
			autoErrorToast: false
		}).then((res: any) => {
			this.verifyCodeTime = 60
			this.startVerifyCodeInterval()
		}).catch((err: any) => {
			this.$message.error(err.message)
			this.$emit('on-refresh-code')
		})
	}
	private startVerifyCodeInterval (): void {
		this.verifyCodeInterval = setInterval(() => {
			if (this.verifyCodeTime <= 0) {
				clearInterval(this.verifyCodeInterval)
			} else {
				this.verifyCodeTime--
			}
		}, 1000)
	}
	private isIntervalIng () {
		return this.verifyCodeTime > 0
	}
}
